import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { ChipsContainer, freeBetStore, roundInfoStore, userInfoStore } from '@pascal/pascal-core';
import { applicationStore } from '@pascal/pascal-core/shared/core/store';
import { doBetStore } from '../../store/doBetStore';
import { gameStore } from '../../store/gameStore';
import { betResponseCodeByName } from '../../enums/betResponseCode';
import { soundService, soundTypes } from '../../services/SoundService';
import { winningAmountStore } from '../../store/winningAmountStore';
import { gameLiveConnection } from '../../services';

const ChipsWrapper = observer(() => {
  const {
    reBet,
    quickBets,
    betsModels,
    reBetAmount,
    selectedChip,
    setDouble,
    setUndoBet,
    setBetsModel,
    setSelectedChip,
    handleNotificationCode,
  } = doBetStore;
  const { isBetsClosed } = gameStore;
  const { balance } = userInfoStore;
  const { setLastWin } = winningAmountStore;
  const { isDemo } = applicationStore;
  const { activeFreeBet } = freeBetStore;

  const handleSelectChips = (chip) => {
    setSelectedChip(chip);
  };

  const handleReBetOrDoubleBet = useCallback(() => {
    setLastWin(0);
    if (reBet && !betsModels.length && !isBetsClosed) {
      if (reBetAmount > balance) {
        handleNotificationCode(betResponseCodeByName.NotEnoughBalance);
        return;
      }
      setBetsModel({ betModel: reBet });
      if (!isDemo) {
        reBet.forEach((item) =>
          gameLiveConnection.sendDoChip({ ...item, roundId: roundInfoStore.roundId })
        );
      }

      soundService.play(soundTypes.Chip);
    } else {
      setDouble();
    }
  }, [
    balance,
    betsModels,
    handleNotificationCode,
    isBetsClosed,
    isDemo,
    reBet,
    reBetAmount,
    setBetsModel,
    setDouble,
    setLastWin,
  ]);

  if (isBetsClosed) {
    return null;
  }

  return (
    <div className={`football-field-chips-row ${activeFreeBet.id ? 'has-free-chip' : ''}`}>
      <div
        className={`field-chip-block-circle ${
          betsModels.length ? '' : 'not-visible'
        } left icon-new-undo`}
        onClick={setUndoBet}
      />
      <ChipsContainer
        selectedChip={selectedChip}
        handleSelectChips={handleSelectChips}
        quickBets={quickBets}
        isFreeChip={!!activeFreeBet.id}
      />
      <div
        className={`${
          betsModels.length || (!betsModels.length && reBet) ? '' : 'not-visible'
        } field-chip-block-circle right icon-${betsModels.length ? 'double' : 'rebet'}`}
        onClick={handleReBetOrDoubleBet}
      />
    </div>
  );
});
export default ChipsWrapper;
